/**
 * Created by vladislav on 22.01.2021
 */

const BonusWorldMissionLogic = function (mission, isNewMission) {
    this.mission = mission;

    const feature = cleverapps.eventManager.getFeatureEvent("bonusworld");
    const type = feature && feature.options.bonusWorldType || BonusWorld.TYPE_VALENTINES;

    this.bonusWorld = new BonusWorld(mission, type);

    if (this.mission.iconForce) {
        this.mission.iconForce.text = `${this.bonusWorld.config.localizationPrefix}.BonusWorld.Force`;
    }

    if (isNewMission) {
        this.clearSavedGames();

        cleverapps.forces.clearForce(Forces.BONUS_WORLD);
    }
};

BonusWorldMissionLogic.prototype.hasIntent = function () {
    return cleverapps.config.type !== "merge";
};

BonusWorldMissionLogic.prototype.willUseIntent = function (level) {
    return level.isBonusWorldLevel();
};

BonusWorldMissionLogic.prototype.processEvent = function (options) {
    this.bonusWorld.onLevelPassed(options.level);
};

BonusWorldMissionLogic.prototype.clearSavedGames = function () {
    if (cleverapps.GameSaver) {
        cleverapps.GameSaver.remove(BonusWorldConfig[this.bonusWorld.type].episode, levelNo);
    }
};